export default __webpack_public_path__ + "static/media/ChemicalIndustry_bg.1810b913.jpg";